export enum ENotificationType {
  Warning = 'warning',
  Notification = 'notification',
}
